(() => {
  'use strict';

  // Const
  // -----
  const MAX_VIEWPORT_WIDTH = 1920;

  window.SMALL_MOBILE_WIDTH = 360;
  window.PORTRAIT_MOBILE_WIDTH = 480;
  window.LARGE_PORTRAIT_MOBILE_WIDTH = 700;
  window.LANDSCAPE_MOBILE_WIDTH = 800;
  window.PORTRAIT_TABLET_WIDTH = 768;
  window.LANDSCAPE_SMALL_TABLET_WIDTH = 900;
  window.LANDSCAPE_TABLET_WIDTH = 980;
  window.DESKTOP_WIDTH = 1024;
  window.DESKTOP_MID_WIDTH = 1160;
  window.DESKTOP_BIG_WIDTH = 1280;
  window.DESKTOP_WIDE_WIDTH = 1366;

  // Selectors
  // ---------
  window.$WINDOW = $(window);
  window.$DOCUMENT = $(document);
  window.$HTML = $(document.documentElement);
  window.$BODY = $(document.body);
  window.$HEADER = $('.header');
  window.$HEADER_MENU = $('.header-menu');
  window.$MENU_CHECKBOX = $('.header-menu-checkbox');

  // Helpers
  // -------
  $WINDOW
    .on('calcSizes', () => {
      window.VIEWPORT_WIDTH = document.documentElement.clientWidth || Math.round(window.visualViewport.width) || $WINDOW.width();
      window.WINDOW_HEIGHT = $WINDOW.height();
      window.HEADER_HEIGHT = $HEADER.height();
    })
    .on('resize', () => {
      $WINDOW.trigger('calcSizes');
    })
    .trigger('calcSizes');

  /**
   * @return boolean
   */
  window.IS_DESKTOP_WIDE_WIDTH = () => VIEWPORT_WIDTH >= DESKTOP_WIDE_WIDTH;
  /**
   * @return boolean
   */
  window.IS_DESKTOP_BIG_WIDTH = () => VIEWPORT_WIDTH >= DESKTOP_BIG_WIDTH;
  /**
   * @return boolean
   */
  window.IS_DESKTOP_MID_WIDTH = () => VIEWPORT_WIDTH >= DESKTOP_MID_WIDTH;
  /**
   * @return boolean
   */
  window.IS_DESKTOP_WIDTH = () => VIEWPORT_WIDTH >= DESKTOP_WIDTH;
  /**
   * @return boolean
   */
  window.IS_WIDTH_MORE_DESKTOP = () => VIEWPORT_WIDTH > DESKTOP_WIDTH;
  /**
   * @return boolean
   */
  window.IS_TABLET_WIDTH = () => (VIEWPORT_WIDTH >= PORTRAIT_TABLET_WIDTH && VIEWPORT_WIDTH < DESKTOP_WIDTH);
  /**
   * @return boolean
   */
  window.IS_WIDTH_LESS_PORTRAIT_TABLET = () => VIEWPORT_WIDTH < PORTRAIT_TABLET_WIDTH;
  /**
   * @return boolean
   */
  window.IS_LANDSCAPE_TABLET_WIDTH = () => VIEWPORT_WIDTH < LANDSCAPE_TABLET_WIDTH;
  /**
   * @return boolean
   */
  window.IS_LANDSCAPE_SMALL_TABLET_WIDTH = () => VIEWPORT_WIDTH < LANDSCAPE_SMALL_TABLET_WIDTH;
  /**
   * @return boolean
   */
  window.IS_MOBILE_WIDTH = () => VIEWPORT_WIDTH < LANDSCAPE_MOBILE_WIDTH;
  /**
   * @return boolean
   */
  window.IS_LARGE_PORTRAIT_MOBILE_WIDTH = () => VIEWPORT_WIDTH < LARGE_PORTRAIT_MOBILE_WIDTH;
  /**
   * @return boolean
   */
  window.IS_PORTRAIT_MOBILE_WIDTH = () => VIEWPORT_WIDTH < PORTRAIT_MOBILE_WIDTH;
  /**
   * @return boolean
   */
  window.IS_SMALL_MOBILE_WIDTH = () => VIEWPORT_WIDTH < SMALL_MOBILE_WIDTH;


  // Defaults
  // --------
  let slickBaseSettings = {
        elementAsContext: true,
        slider: '> div:first-child',
        appendArrows: '.slick-arrows',
        appendDots: '.slick-dots',
        dotsClass: '',
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 300,
        centerMode: false,
        centerPadding: '0px',
        cssEase: 'ease-in-out',
        prevArrow: '<div class="prev"><span class="button-style btn-gradient"></span></div>',
        nextArrow: '<div class="next"><span class="button-style btn-gradient"></span></div>',
        pauseOnDotsHover: true,
        customPaging: () => '<div></div>',
        draggable: true,
        swipeToSlide: true,
        touchThreshold: 100
      },
      unveilSettings = {
        attribute: 'lazySrc',
        placeholder: '',
        offset: 75,
        throttle: 200
      },
      plyrSettings = {
        autoplay: false,
        //volume: 0.5, // не работает. вынес в переменную для отдельных команд
        invertTime: false,
        iconUrl: '/i/plyr.svg',
        controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
        settings: [],
        tooltips: {
          seek: false,
        },
      },
      plyrDefaultVolume = 0.5,
      $portfolioVitrine,
      portfolioFilterLinksSelector = '.portfolio-list .portfolio-filter a',
      getPortfolioFilterValue = () => {
        let hash = decodeURIComponent(location.hash.slice(1)) || 'all',
            selector = '[data-filter~="'.concat(hash, '"]');

        return {
          'isotope': (hash === 'all' ? '*' : selector),
          'selector': selector
        };
      };


  // Masked input
  // ------------
  $('input[type="date"]').attr('type', 'text');

  Inputmask.extendAliases({
    'phone-mask': {
      regex: '(\\+7|8) \\([0-689]\\d{2}\\) \\d{3}(\\-\\d{2}){2}',
      placeholder: '+7 (___) ___-__-__',
      keepStatic: true
    }
  });

  // Phone
  $('input[type="tel"], input[autocomplete="tel"]').inputmask('phone-mask');



  $WINDOW
    .one('load', () => {
      $WINDOW.trigger('calcSizes');
      $DOCUMENT
        .trigger('headerEvents')
        /*.trigger('galleryPackery')*/;
    })
    .on('structureScale', () => {
      $('.structure').css('transform', (VIEWPORT_WIDTH > MAX_VIEWPORT_WIDTH ? 'scale('.concat(VIEWPORT_WIDTH / MAX_VIEWPORT_WIDTH, ')') : ''));
    })
    .on('resize', () => {
      $WINDOW.trigger('structureScale');
      $DOCUMENT
        .trigger('headerEvents')
        /*.trigger('galleryPackery')*/;
    })
    .on('scroll.headerTransparency', function() {
      $HEADER.toggleClass('transparent', $WINDOW.scrollTop() == 0);
    })
    .trigger('structureScale');


  $DOCUMENT
    .ready(() => {
      $WINDOW.on('hashchange', () => {
        if ($portfolioVitrine && $portfolioVitrine.length)
          $portfolioVitrine.trigger('filtering.isotope');
      });


      // Header menu button
      // ------------------
      $MENU_CHECKBOX
        .on('change', e => {
          e.currentTarget.checked ? $BODY.addClass('menu-is-opened') : $BODY.removeClass('menu-is-opened');
        })
        .prop({'checked': false, 'disabled': false})
        .trigger('change');


      // Main rotator
      // ------------
      const firstBlockAutoplaySpeed = 8000,
            firstBlockWithVideoClass = 'with-video',
            firstBlockVideoLoadedClass = 'unveil-loaded',
            firstBlockVideoSelector = '.first-block-video video';
      $('.first-block')
        .one('init.slick', (e, slick) => {
          let $currentSlide = slick.$slides.eq(slick.currentSlide);

          slick.options.autoplaySpeed = parseInt($currentSlide.data('duration')) || firstBlockAutoplaySpeed;

          if ($currentSlide.hasClass(firstBlockWithVideoClass)) {
            let $video = $currentSlide.find(firstBlockVideoSelector);

            $video.on('loadstart', videoEvent => { videoEvent.currentTarget.classList.add(firstBlockVideoLoadedClass); videoEvent.currentTarget.play(); });
            $video.attr('src', $video.data('src'));
          }
        })
        .on('beforeChange', (e, slick, currentSlide, targetSlide) => {
          let $currentSlide = slick.$slides.eq(currentSlide),
              $targetSlide = slick.$slides.eq(targetSlide);

          slick.$container.slick('slickSetOption', 'autoplaySpeed', parseInt($targetSlide.data('duration')) || firstBlockAutoplaySpeed);
          $targetSlide.find('> div:first-child span[data-lazy-src]').data('unveilHidden', 0).trigger('unveil.unveil');

          if ($currentSlide.hasClass(firstBlockWithVideoClass))
            $currentSlide.find(firstBlockVideoSelector).get(0).pause();

          if ($targetSlide.hasClass(firstBlockWithVideoClass)) {
            let $targetVideo = $targetSlide.find(firstBlockVideoSelector);

            if ($targetVideo.hasClass(firstBlockVideoLoadedClass))
              $targetVideo.get(0).currentTime = 0;
            else {
              $targetVideo.on('loadstart', videoEvent => { videoEvent.currentTarget.classList.add(firstBlockVideoLoadedClass); });
              $targetVideo.attr('src', $targetVideo.data('src'));
            }
          }
        })
        .on('afterChange', (e, slick, currentSlide) => {
          let $currentSlide = slick.$slides.eq(currentSlide);

          if ($currentSlide.hasClass(firstBlockWithVideoClass))
            $currentSlide.find(firstBlockVideoSelector).get(0).play();
        })
        .slick($.extend({}, slickBaseSettings, {
          fade: true,
          autoplay: true,
          autoplaySpeed: firstBlockAutoplaySpeed,
          elementAsContext: true,
          slider: '.first-block-rotator > div',
          appendArrows: '.first-block-controls > div',
        }));

      // Photo-text rotator
      // ------------------
      $('.photo-text').slick($.extend({}, slickBaseSettings, {
        autoplay: false,
        infinite: false,
        adaptiveHeight: true,
        slidesToShow: 2,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
            }
          },
        ],
      }));

      // Portfolio section rotator
      // -------------------------
      $('.portfolio-sections').slick($.extend({}, slickBaseSettings, {
        autoplay: false,
        responsive: [
          {
            breakpoint: LARGE_PORTRAIT_MOBILE_WIDTH,
            settings: 'unslick'
          },
        ],
      }));

      // Portfolio layout
      // ----------------
      ($portfolioVitrine = $('.portfolio-list .vitrine.portfolio > div:first-child'))
        .isotope({
          itemSelector: '.vitrine-item',
          layoutMode: 'fitRows',
          percentPosition: true,
          transitionDuration: '0.5s',
          containerStyle: null,
          filter: getPortfolioFilterValue().isotope
        })
        .on('setActiveLink.isotope', (e, selector) => {
          $(portfolioFilterLinksSelector).removeClass('active').filter(selector).addClass('active');
        })
        .on('filtering.isotope', () => {
          let filterValue = getPortfolioFilterValue();

          $portfolioVitrine
            .trigger('setActiveLink.isotope', [filterValue.selector])
            .isotope({filter: filterValue.isotope});
        })
        .on('arrangeComplete.isotope', (e, items) => {
          //console.log('arrangeComplete');
          $(items.map(item => item.element)).find('.portfolio-item-image [data-lazy-src]').trigger('unveil.unveil');
        })
        .trigger('setActiveLink.isotope', [getPortfolioFilterValue().selector]);


      // Lazy load
      // ---------
      $('.first-block-item > div:first-child span[data-lazy-src]').unveil($.extend({}, unveilSettings, {
        attribute: 'lazySrcSm',
        offset: 0,
        breakpoints: [
          {
            minWidth: PORTRAIT_MOBILE_WIDTH,
            attribute: 'lazySrcMd'
          },
          {
            minWidth: DESKTOP_WIDTH,
            attribute: 'lazySrc'
          }
        ]
      }));

      $('.vitrine-item-image [data-lazy-src], .video-frame > a span[data-lazy-src], .gallery-item img, .about-incut [data-lazy-src], .magazine-incut [data-lazy-src], .award-incut [data-lazy-src], .portfolio-page-info [data-lazy-src]').unveil(unveilSettings);
      $('.incut-image')
        .one('load.unveil', (e, data) => {
          if (data)
            $(e.target).css('--image', 'url(\''.concat(data.targetSrc, '\')'));
        })
        .unveil($.extend({}, unveilSettings, {
          //offset: 75,
          backgroundSet: false
        }));


      // Video player init
      // -----------------
      const videos = Plyr.setup('.js-video-player', plyrSettings);

      if (videos !== null)
        videos.forEach(plyr => {
          if (plyr.type === 'video') {
            plyr.volume = plyrDefaultVolume;

            const cssClass = 'plyr--fullscreen-entered';

            plyr.on('enterfullscreen', e => { e.currentTarget.classList.add(cssClass); });
            plyr.on('exitfullscreen', e => { e.currentTarget.classList.remove(cssClass); });
          }
        });

      // Audio player init
      // -----------------
      const audios = Plyr.setup('.js-audio-player audio', $.extend({}, plyrSettings, {
        controls: `<div class="plyr__audio-custom"><div class="plyr__controls"><button class="plyr__control" type="button" data-plyr="play"><svg class="icon--pressed"><use xlink:href="/i/plyr.svg#plyr-pause"></use></svg><svg class="icon--not-pressed"><use xlink:href="/i/plyr.svg#plyr-play"></use></svg></button><div class="plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress></div></div></div><div><div class="plyr__time plyr__time--current">00:00</div><div><div class="plyr__time plyr__time--duration">00:00</div></div></div></div>`,
      }));

      if (audios !== null)
        audios.forEach(plyr => {
          plyr.rangeTouch.setup(plyr.elements.inputs.seek, {addCSS: false, watch: false});
        });
    })

    // Header events
    // -------------
    .on('headerEvents', () => {
      $WINDOW.trigger('scroll.headerTransparency');
      $BODY.css('--header-height', HEADER_HEIGHT + 'px');
      $HEADER.addClass('fixed');

      if (VIEWPORT_WIDTH >= 1446) {
        if (!$BODY.hasClass('is-desktop-events')) {
          $BODY
            .addClass('is-desktop-events')
            .removeClass('is-mobile-events');

          // Header menu desktop events
          // --------------------------
          $DOCUMENT
            .off('click.closeHeaderMenu')
            .off('click.headerMenu');

          $MENU_CHECKBOX.prop('checked', false).trigger('change');

          $HEADER_MENU
            .find('li').removeClass('is-hovered')
            .find('ul').removeAttr('style');
        }
      }
      else {
        if (!$BODY.hasClass('is-mobile-events')) {
          $BODY
            .addClass('is-mobile-events')
            .removeClass('is-desktop-events');

          $HEADER_MENU.find('li.is-opened:not(.is-hovered)').addClass('is-hovered');

          // Header menu mobile events
          // -------------------------
          $DOCUMENT
            // Close header menu
            .on('click.closeHeaderMenu', e => {
              if (!($(e.target).closest('.header-menu-checkbox').length || $(e.target).closest('.header-menu-button').length || $(e.target).closest('.header-menu-button-wrapper + div > div').length)) {
                e.stopPropagation();

                $MENU_CHECKBOX.prop('checked', false).trigger('change');
              }
            })

            // Header menu items
            .on('click.headerMenu', '.header-menu > ul a, .header-menu > ul div > span, .header-menu > ul .dropmarker', e => {
              e.preventDefault();

              let $self = $(e.currentTarget),
                  $parent = $self.closest('li'),
                  isWithDropdown = $parent.hasClass('with-dropdown'),
                  isOnHover = $parent.hasClass('is-hovered');

              if ($self.prop('tagName').toUpperCase() === 'A')
                location.href = $self.prop('href');
              else if (isWithDropdown) {
                if (isOnHover)
                  $parent.removeClass('is-hovered').children('ul').slideUp(300);
                else {
                  //$parent.siblings().removeClass('is-hovered').children('ul').slideUp(300);
                  $parent.addClass('is-hovered').children('ul').slideDown(300);
                }
              }
            });
        }
      }
    })

    // Gallery packery-mode event
    // --------------------------
    /*.on('galleryPackery', (event, $gallery) => {
      let $elements = $gallery || $('.gallery > div:first-child');

      if ($elements.length) {
        if (IS_LANDSCAPE_SMALL_TABLET_WIDTH()) {
          $elements.isotope({
            itemSelector: '.gallery-item',
            layoutMode: 'packery',
            percentPosition: true,
            transitionDuration: '0.5s',
            containerStyle: null,
          });
        }
        else
          $elements.isotope('destroy');
      }
    })*/

    // Slick sliders events
    // --------------------
    .on('beforeChange', '.portfolio-sections, .photo-text', (e, slick, currentSlide, targetSlide) => {
      if (IS_DESKTOP_WIDTH() && slick.$container.data('scrollOnChange'))
        slick.$container.trigger('scrollTo');

      if (slick.currentDirection && targetSlide > currentSlide || !slick.currentDirection && targetSlide < currentSlide) {
        let index = slick.currentDirection ? targetSlide - slick.slideCount : targetSlide + slick.slideCount,
            selector = '';

        for(let i = 0; i < slick.options.slidesToShow; i++, index++)
          selector += (selector.length ? ', ' : '').concat('[data-slick-index="', index, '"]');

        slick.$slideTrack.children().filter(selector).addClass('slick-active-fix');
      }
    })
    .on('afterChange', '.portfolio-sections, .photo-text', (e, slick) => {
      slick.$slideTrack.children().removeClass('slick-active-fix');
    })

    // Portfolio filter
    // ----------------
    .on('click.portfolioFilterLink', portfolioFilterLinksSelector, e => {
      e.preventDefault();

      location.hash = encodeURIComponent($(e.currentTarget).data('filter'));
    })

    // Callback form open
    // ------------------
    .on('click.callbackFormButton', '.btn-callback', e => {
      e.preventDefault();

      let source;

      switch(e.currentTarget.dataset.popupType) {
        case 'magazine':
          source = '#magazine-order-form';
          break;

        default:
          source = '#callback-popup-form';
      }

      $.fancybox.open({
        type: 'inline',
        src: source
      });
    })

    // Video frame load
    // ----------------
    .on('click.videoFrame', '.video-frame > a', e => {
      e.preventDefault();

      let $self = $(e.currentTarget),
          $container = $self.parent(),
          $video = $container.find('[data-src]'),
          platform = $self.data('platform') || false,
          videoConfig = $video.data('plyrConfig') || {},
          afterLoadCallback = video => {
            if (platform) {
              if (platform === 'rutube') {
                video.contentWindow.postMessage(JSON.stringify({type: 'player:setCurrentTime', data: {time: 0}}), '*');
                //video.contentWindow.postMessage(JSON.stringify({type: 'player:setVolume', data: {volume: 0.5}}), '*');
                video.contentWindow.postMessage(JSON.stringify({type: 'player:play', data: {}}), '*');
              }
            }
            else {
              const player = new Plyr(video, $.extend({}, plyrSettings, videoConfig, {
                poster: '',
              }));

              player.volume = plyrDefaultVolume;

              player.on('ready', () => {
                player.play();
              });
            }
          };

      if (($self.data('popup') !== undefined) || (IS_LANDSCAPE_SMALL_TABLET_WIDTH() && ($self.outerWidth() <= (VIEWPORT_WIDTH - 25) / 2))) {
        const ratioHeight = (!platform && videoConfig.ratio) ? parseFloat(videoConfig.ratio.split(':').at(1)) : undefined;

        $.fancybox.open({
          type: (platform ? 'iframe' : 'video'),
          src: $video.data('src'),
          video: {
            autoStart: false,
          },
          ratio: ratioHeight ? (100 / ratioHeight) : undefined,
          afterLoad: fancybox => {
            afterLoadCallback((platform ? fancybox.current.$iframe : fancybox.current.$content.children('video')).get(0));
          },
        });
      }
      else {
        if (platform)
          $video.on('load', e => { afterLoadCallback(e.currentTarget); });

        $video.attr('src', $video.data('src'));
        $container.addClass('active');
      }
    })

    // Faq list
    // --------
    .on('click.faqList', '.faq-list > div', e => {
      e.preventDefault();

      $(e.currentTarget).toggleClass('active').children('div:last-child').slideToggle(200);
    })

    // Design tariff table hover background
    // ------------------------------------
    .on('mouseenter mouseleave', '.design-tariff-table th + th, .design-tariff-table td + td', e => {
      e.preventDefault();

      let $cell = $(e.currentTarget),
          $table = $cell.closest('.design-tariff-table');

      if (e.type === 'mouseenter')
        $table
          .attr('data-active-index', $cell.index())
          .css('--active-height', $table.height() + 'px')
          .addClass('is-hovered');
      else
        $table.removeClass('is-hovered');
    })

    // Photo-text rotator item button
    // ------------------------------
    .on('click.photoTextItemButton', '.photo-text .vitrine-item-button > a', e => {
      e.preventDefault();

      let $self = $(e.currentTarget),
          $container = $self.next(),
          openPopup = () => {
            $.fancybox.open({type: 'inline', src: $container});
          };

      if (!$container.hasClass('loading')) {
        if (!$container.hasClass('loaded')) {
          $container.addClass('loading');
          $.mouseLoader(true);

          $.ajax({
            type: 'POST',
            url: '/ajax/render_content/',
            data: {
              ajaxRender: 'photoTextContent',
              item: $self.data('item'),
            },
            dataType: 'html'
          })
            .done(data => {
              $.mouseLoader(false);

              $container.addClass('loaded').html(data);
              openPopup();
            })
            .fail(() => {
              $.mouseLoader(false);
              alert('Во время загрузки данных возникла ошибка, обновите страницу или попробуйте позже.');
            })
            .always(() => {
              $container.removeClass('loading');
            });
        }
        else
          openPopup();
      }
    })

    // Scroll to
    // ---------
    .on('scrollTo', (e, $element, speed, offset) => {
      if ($element === undefined)
        $element = $(e.target);

      if (speed === undefined)
        speed = $element.data('scrollSpeed') || 200;

      if (offset === undefined)
        offset = $element.data('scrollOffset') || 0;

      $WINDOW.scrollTo($element, {axis: 'y', duration: speed, offset: parseInt(offset) - HEADER_HEIGHT});
    })
    .on('click.jsScrollTo', '.js-scroll-to', e => {
      e.preventDefault();

      let $link = $(e.currentTarget),
          $element = $($link.attr('href').substring($link.attr('href').lastIndexOf('#'))),
          speed = $link.data('scrollSpeed') || 200,
          offset = $link.data('scrollOffset') || undefined;

      $DOCUMENT.trigger('scrollTo', [$element, speed, offset]);
    })

    // Tabs
    // ----
    .on('click.jsTabs', '.js-tabs a', e => {
      e.preventDefault();

      let $self = $(e.currentTarget);

      if (!$self.hasClass('active')) {
        let $container = $self.closest('.js-tabs'),
            $links = $container.find('a'),
            $destination = !!$container.data('tabsDest') ? $($container.data('tabsDest')) : $container.next(),
            cssClass = $container.data('tabCssClass') || 'active';

        $self.addClass('active');
        $links.not($self).removeClass('active');
        $destination.children().removeClass(cssClass).eq($links.index($self)).addClass(cssClass);
      }
    })

    // Show more button
    // ----------------
    .on('click.jsShowMore', '.js-show-more', e => {
      e.preventDefault();

      let $button = $(e.currentTarget),
          requestData = $button.data('showMore');

      if (!$button.hasClass('loading')) {
        $button.addClass('loading');
        $.mouseLoader(true);

        $.ajax({
          type: 'POST',
          url: '/ajax/render_content/',
          data: {
            ajaxRender: requestData.type,
            url: requestData.url,
          },
          dataType: 'html'
        })
          .done(responseData => {
            $.mouseLoader(false);

            let $target = $(requestData.target);

            if ($target.length) {
              $button.parent().addClass('dn');
              $target.append(responseData).find('[data-lazy-src]').unveil(unveilSettings);

              /*if ('packeryAfter' in requestData)
                $DOCUMENT.trigger('galleryPackery', [$target]);*/
            }
          })
          .fail(() => {
            $.mouseLoader(false);
            alert('Во время загрузки данных возникла ошибка, обновите страницу или попробуйте позже.');
            $button.removeClass('loading');
          });
      }
    });


  // FancyBox
  // --------
  $.extend(true, $.fancybox.defaults, {
    autoFocus: false,
    loop: true,
    infobar: false,
    smallBtn: true,
    buttons: [
      false,
      false,
      false,
      'close'
    ],
    idleTime: false,
    transitionEffect: 'slide',
    hash: false,
    mobile: {
      clickSlide: 'close'
    },
    lang: 'ru',
    i18n: {
      ru: {
        CLOSE: 'Закрыть',
        NEXT: 'Следующий слайд',
        PREV: 'Предыдущий слайд',
        ERROR: 'Ошибка загрузки. <br/>Пожалуйста, попробуйте позже.',
        PLAY_START: 'Запустить показ слайдов',
        PLAY_STOP: 'Остановить показ слайдов',
        FULL_SCREEN: 'В полный экран',
        THUMBS: 'Миниатюры',
        DOWNLOAD: 'Скачать',
        SHARE: 'Поделиться',
        ZOOM: 'Масштаб'
      }
    },

    beforeLoad: (widget, current) => {
      switch (current.type) {
        case 'image':
          current.opts.protect = true;
          break;

        case 'inline':
          current.opts.touch = false;
          break;
      }
    },
    afterLoad: (widget, current) => {
      if (current.contentType === 'html' && !IS_MOBILE && !IS_MOBILE_WIDTH())
        current.$content.find('.js-autofocus-inp').trigger('focus');
    }
  });
})();